import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {AuthService} from '@/app/core/services/auth.service';

const CLIENT_TYPES = ['client', 'tenantClient', 'Tenant Client'];

export const tenantOnlyGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const userType = auth.userData()?.user?.type ?? '';
  if (CLIENT_TYPES.includes(userType)) {
    router.navigate(['/home']);
    return false;
  }
  return true;
};
